var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.55224L15.6348 8.10024L6.63482 4.50024L3.53162 5.74104C3.37505 5.80337 3.22801 5.88739 3.09482 5.99064L12 9.55224ZM2.44202 7.02384C2.41403 7.15114 2.39995 7.2811 2.40002 7.41144V16.5866C2.39996 16.9465 2.50774 17.298 2.70945 17.596C2.91116 17.894 3.19754 18.1246 3.53162 18.2582L10.44 21.0218C10.752 21.1466 11.0736 21.2318 11.4 21.2786V10.6058L2.44202 7.02384ZM12.6 21.2798C12.9291 21.2325 13.2513 21.1463 13.56 21.023L20.4684 18.2594C20.8027 18.1258 21.0892 17.8949 21.2909 17.5967C21.4927 17.2985 21.6003 16.9467 21.6 16.5866V7.41144C21.6 7.27944 21.5856 7.14864 21.558 7.02264L12.6 10.6058V21.2798ZM20.9052 5.99184L17.25 7.45464L8.25003 3.85464L10.44 2.97624C11.4414 2.57563 12.5586 2.57563 13.56 2.97624L20.4684 5.73984C20.625 5.80218 20.772 5.88621 20.9052 5.98944",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryActive);
export default __webpack_public_path__ + "static/media/inventory_active.1612444b8a0eb9faef679646bef7d4d9.svg";
export { ForwardRef as ReactComponent };